/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Import_Missing_DialogueInputs */

const en_offline_sync_import_missing_dialogue = /** @type {(inputs: Offline_Sync_Import_Missing_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Missing Dialogue`)
};

const fr_offline_sync_import_missing_dialogue = /** @type {(inputs: Offline_Sync_Import_Missing_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer les dialogues manquants`)
};

const de_offline_sync_import_missing_dialogue = /** @type {(inputs: Offline_Sync_Import_Missing_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlenden Dialog importieren`)
};

const it_offline_sync_import_missing_dialogue = /** @type {(inputs: Offline_Sync_Import_Missing_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa dialogo mancante`)
};

const ru_offline_sync_import_missing_dialogue = /** @type {(inputs: Offline_Sync_Import_Missing_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импортировать отсутствующие диалоги`)
};

const es_offline_sync_import_missing_dialogue = /** @type {(inputs: Offline_Sync_Import_Missing_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar diálogo faltante`)
};

const zh_cn2_offline_sync_import_missing_dialogue = /** @type {(inputs: Offline_Sync_Import_Missing_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入缺失对话`)
};

const ja_offline_sync_import_missing_dialogue = /** @type {(inputs: Offline_Sync_Import_Missing_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不足している会話を取り込む`)
};

const hi_offline_sync_import_missing_dialogue = /** @type {(inputs: Offline_Sync_Import_Missing_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गायब संवाद आयात करें`)
};

const pt_pt2_offline_sync_import_missing_dialogue = /** @type {(inputs: Offline_Sync_Import_Missing_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar diálogo em falta`)
};

/**
* | output |
* | --- |
* | "Import Missing Dialogue" |
*
* @param {Offline_Sync_Import_Missing_DialogueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_import_missing_dialogue = /** @type {((inputs?: Offline_Sync_Import_Missing_DialogueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Import_Missing_DialogueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync_import_missing_dialogue(inputs)
	if (locale === "de") return de_offline_sync_import_missing_dialogue(inputs)
	if (locale === "it") return it_offline_sync_import_missing_dialogue(inputs)
	if (locale === "ru") return ru_offline_sync_import_missing_dialogue(inputs)
	if (locale === "es") return es_offline_sync_import_missing_dialogue(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync_import_missing_dialogue(inputs)
	if (locale === "ja") return ja_offline_sync_import_missing_dialogue(inputs)
	if (locale === "hi") return hi_offline_sync_import_missing_dialogue(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync_import_missing_dialogue(inputs)
	return en_offline_sync_import_missing_dialogue(inputs)
});